// Parse a UTC-midnight date string (from MongoDB) as local midnight,
// preventing the off-by-one-day bug in timezones behind UTC.
export const parseLocalDate = (str) => {
  if (!str) return null;
  const s = typeof str === 'string' ? str : str.toISOString();
  const [y, m, d] = s.slice(0, 10).split('-').map(Number);
  return new Date(y, m - 1, d);
};

// True only if date is strictly before today (yesterday or earlier).
// A task due today is not yet overdue.
export const isOverdue = (date) => {
  if (!date) return false;
  const todayStart = new Date();
  todayStart.setHours(0, 0, 0, 0);
  return date < todayStart;
};

export const fmtDuration = (minutes) => {
  if (!minutes || minutes <= 0) return null;
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;
  if (h === 0) return `${m}m`;
  if (m === 0) return `${h}h`;
  return `${h}h ${m}m`;
};
